import { useEffect, useState } from "react";
import GetCurrencySymbol from "./GetCurrencySymbol";
import { fetchTransactions } from "../api/services/allExpenses";
import { GoArrowUpRight } from "react-icons/go";
import { GoArrowDownLeft } from "react-icons/go";
import { useSelector, useDispatch } from "react-redux";
import { setRecentTransactions } from "../slices/app";
import { FaArrowTrendDown, FaArrowTrendUp } from "react-icons/fa6";

const Admin_RecentTransactions = () => {
  const baseCurrency = localStorage.getItem("baseCurrency");
  // const [transactions, setTransactions] = useState([]);
  const { recentTransactions } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchTransactions().then((state) => dispatch(setRecentTransactions(state)));
  }, []);

  useEffect(() => {
    const handleAiRefresh = () => {
      fetchTransactions().then((state) =>
        dispatch(setRecentTransactions(state)),
      );
    };
    window.addEventListener("ai:refreshExpenses", handleAiRefresh);
    return () =>
      window.removeEventListener("ai:refreshExpenses", handleAiRefresh);
  }, [dispatch]);
  return (
    <div className="h-full min-h-0 w-full bg-white rounded-xl p-3 border shadow-lg flex flex-col border-[#D5D7DA]">
      {/* Header */}
      <div className="flex-shrink-0 mb-2">
        <p className="font-semibold font-customFont">Recent Transactions</p>
      </div>

      {/* Table Scroll Area */}
      <div className="flex-1 min-h-0 overflow-auto scrollbar-thin">
        <table className="w-full border-collapse">
          <thead className="sticky top-0 bg-white z-10 text-gray-600 font-semibold border-b">
            <tr>
              <th className="py-2 px-3 text-left">Transaction</th>
              <th className="py-2 px-3 text-center">Added By</th>
              <th className="py-2 px-3 text-center">Date</th>
              <th className="py-2 px-3 text-center">Amount</th>
            </tr>
          </thead>

          <tbody>
            {recentTransactions?.length === 0 ? (
              <tr>
                <td colSpan="4" className="py-10 text-center text-gray-400">
                  There is no Transaction
                </td>
              </tr>
            ) : (
              recentTransactions.map((transaction) => (
                <tr
                  key={transaction._id}
                  className="border-b hover:bg-gray-100 transition"
                >
                  <td className="p-2 flex gap-2 items-center">
                    <span
                      className={`h-9 w-9 flex items-center justify-center rounded-lg ${
                        transaction.type === "income"
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                      }`}
                    >
                      {transaction.type === "income" ? (
                        <FaArrowTrendUp />
                      ) : (
                        <FaArrowTrendDown />
                      )}
                    </span>
                    <div className="flex flex-col">
                      <span className="font-semibold text-black">
                        {transaction.name}
                      </span>
                      <span className="text-xs text-gray-500">
                        {transaction.project.name}
                      </span>
                    </div>
                  </td>

                  <td className="p-2 text-center">{transaction.user.name}</td>

                  <td className="p-2 text-center">
                    {new Date(transaction.date).toLocaleDateString()}
                  </td>

                  <td
                    className={`p-2 text-center font-bold ${
                      transaction.type === "income"
                        ? "text-green-700"
                        : "text-red-700"
                    }`}
                  >
                    <GetCurrencySymbol currencyId={baseCurrency} />{" "}
                    {(Number(transaction.amount) || 0).toFixed(2)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Admin_RecentTransactions;
